// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4850":"e92d4cb5","6698":"71e3ef40","8458":"ca721e3a"}[chunkId] + ".chunk.css";
};